import React from 'react'
import Skeleton from 'react-loading-skeleton';

function CateogaryPostSkeleton() {
    return (
        <div className="col-lg-4 col-md-6 mt-md-0 mt-4">
            <div className="card">
                <div className="card-header p-0 position-relative">
                    <a href={`/posts/`}>
                        <Skeleton height={`15em`} className="card-img-bottom d-block radius-image-full" />
                    </a>
                </div>
                <div className="card-body blog-details">
                    <Skeleton className="blog-desc" />
                    <div className="author align-items-center">
                        <Skeleton className="img-fluid rounded-circle" />
                    </div>
                </div>
            </div>
        </div>
    )
}

export default CateogaryPostSkeleton
